import { stringifyForDisplay } from './portalHubEventLog';

export type DevJsonDetailsProps = {
  summary: string;
  value: unknown;
};

export function DevJsonDetails({ summary, value }: DevJsonDetailsProps) {
  return (
    <details>
      <summary className="small text-body-secondary" style={{ cursor: 'pointer' }}>
        {summary}
      </summary>
      <pre
        className="small font-monospace mt-1 mb-0 p-2 bg-body-tertiary rounded"
        style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word', maxHeight: '20rem', overflow: 'auto' }}
      >
        {stringifyForDisplay(value)}
      </pre>
    </details>
  );
}
